function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useNavigate, useRevalidator } from 'react-router';

import { useSetAtom } from 'jotai';
import { isEqual } from 'lodash';

import { Translate } from "../../../../I18N";

import * as thesauriAPI from "../../../api/thesauri";
import { notificationAtom } from "../../../atoms";
import { Table } from "../../../Components/UI";
import { InputField } from "../../../Components/Forms";
import { addSelection, sanitizeThesaurusValues } from "./helpers";
import { columnsThesaurus } from "./components/TableComponents";










const ThesaurusForm = ({
  thesaurus,
  thesaurusValues,
  form,
  edit,
  setThesaurusValues,
  setSelectedThesaurusValue
}) => {
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors }
  } = form;

  const navigate = useNavigate();
  const revalidator = useRevalidator();
  const setNotifications = useSetAtom(notificationAtom);

  const handleRevalidate = async (savedThesaurus) => {
    if (!(thesaurus !== null && thesaurus !== void 0 && thesaurus._id)) {
      await navigate(`../edit/${savedThesaurus._id}`, { replace: true });
    } else {
      await revalidator.revalidate();
    }
  };

  const saveThesaurus = async (data) => {
    const thesaurusToUpdate = _objectSpread(_objectSpread({}, data), {}, { values: sanitizeThesaurusValues(thesaurusValues) });
    const savedThesaurus = await thesauriAPI.save(thesaurusToUpdate);
    setValue('_id', savedThesaurus._id);
    setNotifications({
      type: 'success',
      text: thesaurus ? /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Thesauri updated.") : /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Thesauri added.")

    });
    await handleRevalidate(savedThesaurus);
  };

  const formSubmit = async (data) => {
    try {
      await saveThesaurus(data);
    } catch (e) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Error updating thesauri.")
      });
    }
  };

  return (/*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(formSubmit), id: "edit-thesaurus" }, void 0, /*#__PURE__*/
    _jsx("div", { "data-testid": "thesauri", className: "border rounded-md shadow-sm border-gray-50" }, void 0, /*#__PURE__*/
    _jsx(Table, {
      data: thesaurusValues,
      columns: columnsThesaurus({ edit }, thesaurus),
      dnd: { enable: true, disableEditingGroups: true },
      enableSelections: true,
      header: /*#__PURE__*/
      React.createElement(InputField, _extends({
        clearFieldAction: () => {},
        id: "thesauri-name",
        placeholder: "Thesauri name",
        hasErrors: !!errors.name,
        className: "flex-grow" },
      register('name', { required: true }))
      ),

      onChange: ({ selectedRows, rows }) => {
        setSelectedThesaurusValue(() => {
          const selection = [];
          thesaurusValues.forEach((item) => {var _item$subRows;
            addSelection(selectedRows, selection)(item);
            (_item$subRows = item.subRows) === null || _item$subRows === void 0 ? void 0 : _item$subRows.forEach(addSelection(selectedRows, selection));
          });
          return [...selection];
        });
        if (!isEqual(rows, thesaurusValues)) {
          setThesaurusValues(rows);
        }
      } }
    )
    )
    ));

};

export { ThesaurusForm };